import * as React from "react";
import { FC } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { useRecoilValue } from "recoil";
import { userState } from "../../../../states/userState";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@mui/material";
const classes = {
  statusMenu: {
    "& .MuiOutlinedInput-input": {
      paddingBottom: "7px",
      paddingTop: "7px",
    },
  },
};
type DateSelectorProps = {
  label: string;
  value: number;
  options: { id: number; name: string }[];
  select: (value: number) => void;
  required: boolean;
  disabled: boolean;
};

const SelectBox: FC<DateSelectorProps> = (props) => {
  const user = useRecoilValue(userState);
  const theme = useTheme();
  return (
    <FormControl
      variant="standard"
      sx={{
        width: "110px",

        // marginBottom: "10px",
      }}
    >
      {/* <InputLabel sx={{ color: theme.palette.foreColor.main }}>
        {props.label}
      </InputLabel> */}
      <Select
        disabled={props.disabled}
        required={props.required}
        value={props.value}
        onChange={(event) => props.select(event.target.value as number)}
        // onChange={(event) => props.select(event.target.value)}
        // IconComponent={() => (
        //   <ArrowDropDownIcon
        //     style={{
        //       color: foreColorCode(user?.mode ?? "dark"),
        //       cursor: "pointer",
        //     }}
        //   />
        // )}
        label={props.label} // MUI v5では、選択した値とラベルを適切に揃えるためにこれを追加する必要があるかもしれません
        sx={{
          color: theme.palette.foreColor.main,
          height: "38px",
          paddingLeft: "10px",
          fontSize: "0.8rem",
          "& .MuiSvgIcon-root": {
            color: theme.palette.foreColor.main,
          },
          "&icon": {
            color: "blue",
          },
          borderRadius: "5px",
          backgroundColor: theme.palette.backColor.main,
          "& .MuiSelect-select": {
            color: theme.palette.foreColor.main,
            backgroundColor: theme.palette.backColor.main, // 選択エリアの背景色を設定
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem
            key={option.id}
            value={option.id}
            sx={{
              fontSize: "0.8rem",
              color: theme.palette.foreColor.main,
              backgroundColor: theme.palette.backColor.main, // メニューエリアの背景色を設定
              // 選択された状態のスタイル
              "&.Mui-selected": {
                backgroundColor: theme.palette.backColor.main, // 選択時の背景色を変更
                color: theme.palette.foreColor.light, // 選択時の文字色を変更
              },

              // ホバー状態のスタイルも定義できます
              "&:hover": {
                backgroundColor: theme.palette.backColor.main, // ホバー時の背景色を変更
                color: theme.palette.foreColor.light, // ホバー時の文字色を変更
              },
              // 選択されていてさらにホバーされた状態のスタイル
              "&.Mui-selected:hover": {
                backgroundColor: theme.palette.backColor.main, // 選択 + ホバー時の背景色
                color: theme.palette.foreColor.light, // 選択 + ホバー時の文字色
              },
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBox;
